import React from "react";
import Image from "next/image";
import GooglePlay from "../../../../public/GooglePlay.png";

export const GooglePlayButton = () => {
  return <Image src={GooglePlay} height={40} width={134} loading="lazy" decoding="async" alt="Google play" />;
};
